import React from 'react';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';

const PinTransfer = () => {

  const [Pintransfer, setPintransfer] = useState([]);

  const getPintransfer = async () => {
    try {
      const response = await axios.get("https://fakestoreapi.com/products?limit=10");
      const empData = response.data;
      setPintransfer(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getPintransfer();
  }, []);


  return (
    <div>

      <Container>

        <div className='container'>
          <div className='row '>
            <div className='col-lg-12 '>
              <div className='row ' style={{ display: "flex" }} >
              </div>
              <div className="row ">
                <div className="col-lg-6 mt-4  ">

                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header" style={{ backgroundColor: "rgb(0,156,216)", color: 'white' }}>
                      <h4> Pin Transfer </h4>
                    </div>
                    <div className="card-body">
                      <div className="">
                        <ButtonGroup className="mb-2">
                          {/* <Button>Copy </Button>
                          <Button>Excel</Button> */}
                          <Button>Download PDF</Button>
                          {/* <Button>Column visibility</Button> */}
                        </ButtonGroup>
                      </div>
                      <form>
                        <div className="card-body">
                          <div className='table-responsive'>
                            <table className="table table-bordered">

                              <thead>
                                <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">Form Name</th>
                                  <th scope="col">Pin Number</th>
                                  <th scope="col">TO Name</th>
                                  <th scope="col">Pin Number</th>
                                  <th scope="col">Remark</th>
                                  <th scope="col">Action</th>


                                </tr>
                              </thead>


                              <tbody>
                                {
                                  Pintransfer.map((product, index) => (
                                    <tr key={index}>
                                      <td>{product.id}</td>
                                      <td>{product.title}</td>
                                      <td>{product.price}</td>
                                      <td>{product.id}</td>
                                      <td>{product.title}</td>
                                      <td>{product.price}</td>

                                      <td>
                                        <button className='btn btn-success mx-2'>Accept</button>
                                        <button className='btn btn-danger mx-2 mt-1'>Reject</button>
                                      </td>
                                    </tr>
                                  ))
                                }
                              </tbody>


                            </table>
                            <nav aria-label="...">
                              <ul class="pagination">
                                <li class="page-item disabled">
                                  <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                </li>
                                <li class="page-item"><a class="page-link" href="#">1</a></li>
                                <li class="page-item active" aria-current="page">
                                  <a class="page-link" href="#">2</a>
                                </li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item">
                                  <a class="page-link" href="#">Next</a>
                                </li>
                              </ul>
                            </nav>
                          </div>

                        </div>
                        {/* /.card-body */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>










            </div>

          </div>


        </div>



      </Container>

    </div>
  )
}

export default PinTransfer;